import { call, put } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  add as addUserRole
} from '../redux/userRoles'

export default function * fetchUsersByRole (action) {
  const { role, onEnd } = action.payload

  const { UserId } = yield call(apiGetData, 'UsersInRole', {
    role
  })

  yield put(UserId.map(userId => addUserRole({
    userId,
    role
  })))

  if (onEnd) onEnd()
}
